import React, { useEffect } from 'react';
import Select from 'components/Form/Select2';
import _orderBy from 'lodash-es/orderBy';
import useSchools from 'queries/schools/useSchools';
import { School } from 'types/school';
import { useTranslation } from 'react-i18next';

interface Props {
  value?: School;
  onChange: (v?: School) => void;
  schoolyearId?: string;
  disabled: boolean;
}

export function SchoolSelector(props: Props) {
  const { data, isInitialLoading } = useSchools({
    schoolyearId: props.schoolyearId,
  });
  const { t } = useTranslation(['common']);
  const schools = data || [];
  useEffect(() => {
    if (schools.length > 0) {
      if (!schools.map(sc => sc.id).includes(props.value?.id || '')) {
        props.onChange(schools[0]);
      }
    }
  }, [props.schoolyearId, isInitialLoading]);
  const { value } = props;
  return (
    <Select
      fill
      disabled={props.disabled}
      loading={isInitialLoading}
      value={value?.id}
      large
      label={t('common:labels.school')}
      options={_orderBy(data || [], 'name', ['asc']).map(sc => ({
        label: sc.name,
        value: sc.id,
      }))}
      onChange={v => props.onChange(schools.find(sc => sc.id === v))}
    />
  );
}
